export default [
  {
    type: 'select',
    placeholder: '设备类型',
    filed: 'series',
    default: '',
    options: [
      {
        code: '冰箱',
        name: '冰箱'
      },
      {
        code: '平调',
        name: '平调'
      },
      {
        code: '陈列柜',
        name: '陈列柜'
      }
    ]
  },
  {
    type: 'input',
    placeholder: '设备型号',
    filed: 'model',
    default: ''
  }
]
